<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

const colors = ['secondary', 'danger', 'success', 'warning', 'info', 'light', 'dark']

export default defineComponent({
  name: 'Alert',
  props: {
    color: {
      type: String,
      validate: (value: string) => colors.includes(value),
    },
  },
  setup(props) {
    const classes = computed(() => {
      const c = ['ui-alert']
      if (props.color) {
        c.push(`ui-alert--${props.color}`)
      }
      return c
    })
    return { classes }
  },
})
</script>

<style lang="stylus">
.ui-alert
  position relative
  margin-bottom 1rem
  padding .75rem 1.25rem
  border 1px solid transparent
  border-radius .25rem

  &--secondary
    color var(--secondary-dark-color)
    background-color var(--secondary-light-color)

  &--success
    color var(--success-dark-color)
    background-color var(--success-light-color)

  &--danger
    color var(--danger-dark-color)
    background-color var(--danger-light-color)

  &--warning
    color var(--warning-dark-color)
    background-color var(--warning-light-color)

  &--info
    color var(--info-dark-color)
    background-color var(--info-light-color)

  &--light
    color var(--text-gray-color)
    background-color #fff

  &--dark
    color var(--darker-color)
    background-color #d0d4d9
</style>
